var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row mb-20"},[_c('div',{staticClass:"col-12"},[_c('a',{on:{"click":function($event){return _vm.openPage()}}},[_vm._v("open link")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }